import { z } from 'zod';
import { isoDateTime, shortText, uuid } from './primitives.js';
/**
 * A session's slide deck — optional, and a session may have several, shown as
 * sub-tabs of the Deck tab in `orderIndex` order. Learners see one either from
 * a PDF, rendered page by page in the browser (a browser cannot draw a .pptx),
 * or as an HTML presentation — one file, or a zipped folder — run in a
 * sandboxed frame. A .pptx uploaded as the deck is converted to a PDF on the
 * server and kept as the deck's download; the original presentation can also
 * ride along as a download of any other deck.
 *
 * No storage URLs live in here: they are minted per request by
 * `GET /api/sessions/:sessionId/decks/:deckId/file`, so a page left open for
 * an hour still opens the deck.
 */
/** A PDF, a single HTML page, or a zipped folder holding a deck page and its files. */
export const deckFormat = z.enum(['pdf', 'html', 'zip']);
export const sessionDeck = z.object({
    id: uuid,
    /** Its place among the session's decks. */
    orderIndex: z.number().int(),
    title: z.string(),
    /** Which viewer draws the deck. */
    format: deckFormat,
    /** The file the trainer uploaded: the PDF, the HTML page, or the .zip. */
    fileName: z.string(),
    fileSize: z.number().int(),
    /** For a zipped deck, the page inside the archive the deck opens on. */
    entryPath: z.string().nullable(),
    /** The original presentation, for download only. */
    source: z
        .object({
        fileName: z.string(),
        size: z.number().int(),
    })
        .nullable(),
    updatedAt: isoDateTime,
});
export const updateDeckRequest = z.object({
    title: shortText.trim().min(1),
});
/**
 * Which of the deck's two files a link is wanted for: the one learners see, or
 * the original presentation. `pdf` is the name `deck` had before HTML decks.
 */
export const deckFileKind = z
    .enum(['deck', 'pdf', 'source'])
    .transform((k) => (k === 'pdf' ? 'deck' : k));
export const deckFileResponse = z.object({
    url: z.string(),
    expiresInSec: z.number().int(),
});
//# sourceMappingURL=decks.js.map